import React, { Component } from 'react';
import { Modal, message, Spin } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import ComList from '../ComList';

const monthFormat = "YYYY-MM";
const positionEnglishOptions = ['CRA', 'CRC', 'PM', 'DM', 'QA', 'QC', 'Data Entry', 'Laboratory Technician', 'Trainee'];

/**
 * 三种工作经历
 * 1、自动生成：isCopy为0，experienceType为MEDKEY
 * 2、复制新增：isCopy为1，experienceType为MEDKEY
 * 3、新增：isCopy为0，experienceType为NON_MEDKEY
 */

class UpdateWorkHistory extends Component {
    state = {
        type: '',
        params: {},
        hasEdit: false,
        visible: false,
        loading: false,
        positionOptions: [],
    }

    show = (record, type) => {
        const { isChinese } = this.props;
        const {
            workDutyChinese,
            workDutyEnglish,
            positionChineseName,
            positionEnglishName,
            isClinicalTrial,
        } = record;
        const params = {
            ...record,
            workDutyChinese: workDutyChinese ? workDutyChinese.slice(0, 10000) : '',
            workDutyEnglish: workDutyEnglish ? workDutyEnglish.slice(0, 10000) : '',
            isClinicalTrial: isClinicalTrial ? isClinicalTrial : '0',
        };
        this.setState({
            type,
            params,
            visible: true,
            positionOptions: [],
        }, () => {
            const { params: { experienceType } } = this.state;
            // 复制或新建的工作经历
            if (type === 'add' || experienceType === 'NON_MEDKEY') {
                this.queryWorkPosition(isChinese ? positionChineseName : positionEnglishName);
            } else {
                this.queryWorkPosition('');
            }
        });
    }

    hide = () => {
        this.setState({
            hasEdit: false,
            visible: false,
        });
    }

    queryWorkPosition = (keyword) => {
        const { params: { experienceType } } = this.state;
        const options = {
            method: 'POST',
            url: API_URL.personal.queryWorkPosition,
            data: {
                keyword,
                typeName: experienceType || 'NON_MEDKEY',
            },
            dataType: 'json',
            doneResult: res => {
                const { data = [] } = res;
                const options = data.map(item => {
                    const { vitaeWorkPositionId, positionName, englishName, positionDuty, positionDutyEnglish } = item;
                    return {
                        zh: positionName,
                        en: englishName,
                        positionDuty,
                        positionDutyEnglish,
                        value: vitaeWorkPositionId,
                    };
                });
                this.setState({ positionOptions: options });
            }
        };
        $.sendRequest(options);
    }

    getRenderList = () => {
        const { isChinese } = this.props;
        const { type, visible, positionOptions, params: { isCopy, experienceType, positionEnglishName } } = this.state;
        positionOptions.forEach(i => i.name = isChinese ? i.zh : i.en);
        const isJinShi = type === 'copy' || isCopy === '1';
        const renderList = [
            [{
                zh: '工作时间',
                en: 'Time',
                key: 'workStartTime',
                require: true,
                option: {
                    type: 'monthPicker',
                    allowClear: false,
                    format: monthFormat,
                    disabled: !isChinese,
                    style: { width: 135 },
                    placeholder: isChinese ? '请选择' : 'Please select ',
                },
                attr: {
                    right: { width: 135 }
                },
            }, {
                zh: '到',
                en: 'To',
                key: 'workEndTime',
                colon: true,
                option: {
                    type: 'monthPicker',
                    allowClear: false,
                    format: monthFormat,
                    disabled: !isChinese,
                    placeholder: isChinese ? '不填写代表至今' : "Present",
                },
                attr: {
                    left: { width: 32, padding: '0 10px' },
                    right: { width: 135 },
                },
            }], {
                zh: '公司',
                en: 'Company',
                key: isChinese ? 'workCompany' : 'workCompanyEnglish',
                require: true,
                option: {
                    type: 'input',
                    style: { width: 302 },
                    disabled: experienceType === 'MEDKEY',
                    placeholder: isChinese ? '请输入' : 'Please input ',
                }
            }
        ];
        if (visible) {
            if (isChinese) {
                renderList.push({
                    zh: '职务',
                    en: 'Position',
                    key: isJinShi ? 'positionId' : 'positionChineseName',
                    require: true,
                    option: {
                        type: isJinShi ? 'select' : 'autoComplete',
                        allowClear: false,
                        list: positionOptions,
                        style: { width: 302 },
                        placeholder: '请选择',
                    }
                });
            } else {
                const option = positionEnglishOptions.find(i => i === positionEnglishName);
                renderList.push({
                    zh: '职务',
                    en: 'Position',
                    key: 'positionEnglishName',
                    require: true,
                    option: {
                        type: 'input',
                        allowClear: false,
                        list: positionOptions,
                        style: { width: 302 },
                        disabled: !!option || isCopy === '1',
                        placeholder: 'Please input ',
                    }
                });
            }
        }
        renderList.push({
            zh: '工作职责',
            en: 'Responsiblity',
            key: isChinese ? 'workDutyChinese' : 'workDutyEnglish',
            require: true,
            option: {
                type: 'textArea',
                style: { width: 460 },
                limit: 10000,
                rows: 6,
                placeholder: isChinese ? '请填写' : 'Please write ',
            }
        });
        if (isChinese && (type === 'add' || experienceType === 'NON_MEDKEY')) {
            renderList.push({
                zh: '是否与临床项目有关',
                key: 'isClinicalTrial',
                require: true,
                option: {
                    type: 'radio',
                    list: [{
                        label: '是',
                        value: '1',
                    }, {
                        label: '否',
                        value: '0',
                    }],
                    placeholder: isChinese ? '请选择' : 'Please select ',
                }
            })
        }
        const setName = (item) => {
            if (isChinese) {
                item.name = item.zh;
            } else {
                item.name = item.en;
            }
        };
        const loopArr = (arr) => {
            if (Array.isArray(arr)) {
                arr.forEach(item => loopArr(item));
            } else {
                setName(arr);
            }
        };
        loopArr(renderList);
        this.renderList = renderList;
    }

    checkValue = param => {
        const { params } = this.state;
        const { name, key, require, option, warning, display } = param;
        const { placeholder } = option;
        
        let noError = true;
        if (require) {
            if (!params[key] && !display) {
                message.warning(`${placeholder}${warning || name || ''}`);
                noError = false;
            } else {
                if (display) {
                    const { symbol, key, value = null } = display;
                    if (symbol === 'eq') {
                        if (value) {
                            const list = this.renderList || [];
                            const tar = list.find(i => i.key === key);
                            const arr = tar.option.list || [];
                            const o = arr.find(a => a.value == params[key]);
                            if (o && o.name === value && !params[param.key]) {
                                message.warning(`${placeholder}${warning || name || ''}`);
                                noError = false;
                            }
                        } else {
                            if (params[key] && !params[param.key]) {
                                message.warning(`${placeholder}${warning || name || ''}`);
                                noError = false;
                            }
                        }
                    }
                }
            }
        }
        return noError;
    }

    confirm = () => {
        const { type, params, hasEdit } = this.state;
        const { isCopy, experienceType } = params;
        if (isCopy === '0' && experienceType === 'MEDKEY' && type === 'edit' && hasEdit) {
            Modal.confirm({
                iconType: 'exclamation-circle',
                title: '确定要修改吗？',
                content: '自动生成的工作经历一旦修改后，系统将不再自动维护',
                onOk: this.submit,
            });
        } else {
            this.submit();
        }
    }

    submit = () => {
        const {
            type,
            params,
            params: {
                workStartTime,
                workEndTime,
                experienceType,
                isCopy,
            },
        } = this.state;
        const { userId } = this.props;
        this.getRenderList();
        const renderList = this.renderList || [];
        const hasError = renderList.every(item => {
            if (Array.isArray(item)) {
                return item.every(i => this.checkValue(i));
            } else {
               return this.checkValue(item);
            }
        });
        if (!hasError) {
            return;
        }

        let url;
        if (type === 'edit') {
            url = API_URL.personal.updateVitaeWorkExperience;
        } else {
            url = API_URL.personal.addVitaeWorkExperience;
        }
        params.workStartTime = workStartTime ? workStartTime.slice(0, 7) : '';
        params.workEndTime = workEndTime ? workEndTime.slice(0, 7) : '';
        const newParams = {};
        if (type === 'copy'){
            newParams.isClinicalTrial = '';
        }
        params.isCopy = (type === 'copy' || isCopy === '1' || (type === 'edit' && experienceType === 'MEDKEY')) ? 1 : 0;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url,
            data: {
                userId,
                ...params,
                ...newParams,
                typeName: experienceType || 'NON_MEDKEY',
            },
            dataType: 'json',
            doneResult: res => {
                message.success(type === 'copy' ? '复制修改成功' : res.success);
                this.setState({
                    loading: false,
                }, () => {
                    this.hide();
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    handleChange = (value, key) => {
        const { isChinese } = this.props;
        const { params, positionOptions } = this.state;
        params[key] = value;
        const workDuty = isChinese ? 'workDutyChinese' : 'workDutyEnglish';
        if (key === workDuty) {
            if (value && value.length > 10000) {
                message.warning('工作职责最大可输入10000！');
                return;
            }
        } else if (key === 'positionId') {
            const option = positionOptions.find(i => i.value == value);
            const { zh, en, positionDuty, positionDutyEnglish } = option || {};
            params.positionChineseName = zh;
            params.positionEnglishName = en;
            params[workDuty] = isChinese ? positionDuty : positionDutyEnglish;
        } else if (key === 'positionChineseName' || key === 'positionEnglishName') {
            const option = positionOptions.find(i => i.name == value);
            if (option) {
                const { zh, en } = option || {};
                params.positionChineseName = zh;
                params.positionEnglishName = en;
            } else {
                if (key === 'positionChineseName') {
                    params.positionChineseName = value;
                } else if (key === 'positionEnglishName') {
                    params.positionEnglishName = value;
                }
            }
        }
        this.setState({
            params,
            hasEdit: true,
        });
    }

    handleSearch = (value) => {
        if (this.timer) {
            clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => {
            this.queryWorkPosition(value);
        }, 300);
    }

    render() {
        const { type, visible, loading, params } = this.state;
        this.getRenderList();
        const list = this.renderList || [];
        const title = (type === 'copy' && '复制新增') || (type === 'edit' && '修改工作经历') || (type === 'add' && '新增工作经历');
        return (
            <Modal
                title={title}
                visible={visible}
                onCancel={this.hide}
                onOk={this.confirm}
                className="create-modal EditPersonModal"
                confirmLoading={loading}
                maskClosable={false}
                width="700px"
            >
                 <Spin spinning={loading}>
                    <div className="modal-content" style={{ padding: '0 20px' }}>
                        <ComList
                            list={list}
                            params={params}
                            onChange={(value, key) => this.handleChange(value, key)}
                            onSearch={(value, key) => this.handleSearch(value, key)}
                        />
                    </div>
                </Spin>
            </Modal>
        )
    }
}

export default UpdateWorkHistory;


// WEBPACK FOOTER //
// ./src/components/common/curriculumVitae/UpdateWorkHistory.js